const getters = {
    access_token: state => state.user.access_token,
    refresh_token: state => state.user.refresh_token,
    loading: state => state.app.loading,
    myVideoListTag : state => state.video.myVideoListTag
}
export default getters